export function normalizeString(input: string): string {
  return input.toLowerCase().replace(/[\W_]+/g, '') // Lowercase & remove non-alphanumeric chars
}
